import React, { ReactNode } from 'react'

type CircledIconProps = {
  icon: ReactNode
  className?: string
  label?: string
}

export const CircledIcon = ({ icon, className, label }: CircledIconProps) => {
  let classNames =
    'rounded-full p-2 size-11 transition min-h-11 min-w-11 flex items-center justify-center bg-surface-tinted text-text-default'
  if (className != null) {
    classNames += ` ${className}`
  }
  return (
    <div
      aria-label={label}
      className={classNames}
      data-tooltip={label}
      role={label != null ? 'img' : undefined}
    >
      {icon}
    </div>
  )
}
